import { Link } from "@mui/material";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose your games.",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MiLB.com",
    description: (
      <>
        Click Continue and connect your Wisconsin Timber Rattlers account using
        our secure{" "}
        <Link target="_blank" href="https://www.milb.com/">
          MiLB.com
        </Link>{" "}
        login.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Wisconsin Timber Rattlers account within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "When will I receive my tickets?",
    description: (
      <>
        Tickets will be made available within 24 hours on{" "}
        <Link
          href={
            "https://mlb.tickets.com/?agency=WTRM_MYTIXX&orgid=56390#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DWTRM_MYTIXX%26orgid%3D56390%23%2F"
          }
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Wisconsin Timber Rattlers Tickets Account
        </Link>
        .
      </>
    ),
  },
  {
    title: "Is re-entry allowed?",
    description:
      "Yes, once you enter our ballpark, you are allowed to go in and out as you wish. Just keep in mind that bags will be checked upon entry each time you re-enter the park.",
  },
  {
    title: "Where are my Opening Day tickets?",
    description:
      "Opening Day tickets for 2025 will be uploaded into your online account sometime after the New Year. We will keep everyone posted on when that date will be.",
  },

  {
    title: "What if I want to change seat locations?",
    description:
      "Changing seat locations or dates of games selected can be done by stopping by or calling our ticket office at 920-733-4152",
  },
];

export function TermsAndCondition() {
  return (
    <>
      By checking this box you agree to receive SMS alerts regarding ticket
      delivery and agree to the Timber Rattlers{" "}
      <Link
        href={"https://www.milb.com/wisconsin/tickets/ticketback/"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Ticket Terms & Conditions
      </Link>
      ,{" "}
      <Link
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}

export function CheckoutTermsAndCondition() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the Timber Rattlers{" "}
      <Link
        href={"https://www.milb.com/wisconsin/tickets/ticketback/"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Ticket Terms & Conditions
      </Link>
      ,{" "}
      <Link
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}
